module.exports = __webpack_public_path__ + "14four/static/media/FrostBorderBottom.409d789d.png";